import { getObtenerProductoCancelar } from '@/services/Reservas/getObtenerProductoCancelar.js';
import { deleteCancelarProducto } from '@/services/Reservas/deleteCancelarReserva.js';
import { ConfigStore } from "../Config/config.store.js";


export const ObtenerProductoCancelar = {
    namespaced: true,
    state: {
        obtenerProductoCancelar: [],
        reservaProducto: 0,
    },
    mutations: {
        setObtenerProductoCancelar(state, payload) {
            state.obtenerProductoCancelar = payload.data;
        },
        setReservaProducto(state, payload) {
            state.reservaProducto = payload.data
        }
    },
    getters: {
        getProducto(state) {
            return state.obtenerProductoCancelar
        },
        getReservaProducto(state) {
            return state.obtenerProductoCancelar
        }
    },
    actions: {
        getObtenerProductoCancelar: async function ({ commit }, token) {
            const response = await getObtenerProductoCancelar(
                `${process.env.VUE_APP_API_URL}${ConfigStore.state.endpoints.getObtenerProductoCancelar}`,
                token
            );
            if (response.status === 200) {
                commit("setObtenerProductoCancelar", response.data);
            }
            return response;
        },

        deleteCancelarProducto: async function ({ commit }, datos) {
        
            const response = await deleteCancelarProducto(`${process.env.VUE_APP_API_URL}${ConfigStore.state.endpoints.deleteCancelarProducto}`, datos.dni, datos.token)
            if (response.status === 200) {
                commit("setReservaProducto", response.data);
            }
            return response;
        }
    }
}
